import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

import type {
  GetSignedMissingItemFormPdfRequestDTO,
  GetSignedMissingItemFormPdfResponseDTO,
} from './DTOs';

/**
 * Missing-item signed PDF API (Framework Agnostic)
 *
 * POC endpoint: returns an existing signed PDF blob if present.
 */
@Singleton
export class MissingItemSignedPdfApi extends AuthApi {
  constructor() {
    super();
  }

  async getSignedMissingItemFormPdf(
    body: GetSignedMissingItemFormPdfRequestDTO,
  ): Promise<Result<GetSignedMissingItemFormPdfResponseDTO, AppError>> {
    return wrapHttpCall(() =>
      this.api.get<GetSignedMissingItemFormPdfResponseDTO>(
        `/MissingItemForm/${body.missingItemFormId}/signedmissingitemformpdf`,
        {
          responseType: 'blob',
        },
      ),
    );
  }
}

